import styled from 'styled-components';
// styles for mobile devices
export const PageWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: ${(props) => props.theme.palette.secondary.main};
  @media (orientation: landscape) {
    flex-direction: row-reverse;
  }
`;
// styles for desktop view
export const PageWrapperDesktop = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: ${(props) => props.theme.palette.tertiary.main};
`;
